<template>
	<div>
		<Header v-if="!isMobile"></Header>
		<header-wx v-if="isMobile"></header-wx>
		<div :class="isMobile?'mainContentBoxs':'mainContentBox'">
			<router-view></router-view>
		</div>
		<Footer v-if="!isMobile"></Footer>
		<footer-wx v-if="isMobile"></footer-wx>
	</div>
</template>

<style lang="less" scoped>
	.mainContentBox {
		margin: 0 auto;
		min-height: calc(100vh - 80px - 170px);
	}
	.mainContentBoxs{
		margin: 0 auto;
		min-height: calc(100vh - 80px - 170px);
		margin-top: 70px;
	}
</style>

<script>
	import Header from "./Header";
	import Footer from "./Footer";
	import HeaderWx from './Header-Wx'
	import FooterWx from './Footer-Wx'
	export default {
		name:'CommonLayout',
		components: {
			Header,
			HeaderWx,
			Footer,
			FooterWx
		},
		mounted(){
			//console.log(this.isMobile)
		}
	}
</script>